import { initHamburger } from '../../../../Common/Resources/src_front/js/satellites/initHumburger';
import { initAccordion } from '../../../../Common/Resources/src_front/js/satellites/initAccordion';
import { scrollTo } from './scrollTo';
import { pushengage } from '../../../../Common/Resources/src_front/js/pushengage';
import { lazyLoadAnalytics } from '../../../../Common/Resources/src_front/js/utils/lazyLoadAnalytics';

window.addEventListener('DOMContentLoaded', onLoad, false);

function onLoad() {
    initHamburger();
    initAccordion();
    scrollTo();
    lazyLoadAnalytics(pushengage);
}
